import React, { useState } from "react";
import ContactFormDW from "./ContactFormDW";
function HomeDW() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [haveBusiness, setHaveBusiness] = useState(0);
  return (
    <main className="page">
      <section
        className={"promo _watcher-view"}
        style={{ marginBottom: "0", height: "100svh" }}
      >
        <div className="promo__container">
          <div className="promo__body">
            <div className="promo__content">
              <pre className="promo__title">
                Підвищимо рейтинг
                <br />
                Вашого бізнесу
                <br />
                на Google Maps&nbsp;
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/a/aa/Google_Maps_icon_%282020%29.svg"
                  style={{
                    height:
                      "clamp(1.875rem, 1.3961786372rem + 2.394106814vw, 3.5rem)",
                  }}
                  alt="Google Maps Icon"
                />
              </pre>
              <div className="promo__text">Чи є у вас діючий бізнес?</div>
              <div className="promo__buttons promo__buttons_dw">
                <button
                  className="promo__contact button"
                  onClick={() => {
                    setHaveBusiness(2);
                    setIsContactFormOpen(true);
                  }}
                >
                  Бізнесу поки що немає
                </button>
                <button
                  className="form-block__btn button"
                  onClick={() => {
                    setHaveBusiness(1);
                    setIsContactFormOpen(true);
                  }}
                >
                  Так, у мене є бізнес
                </button>
              </div>
            </div>
            <div className="promo__presentation">
              <div
                className="promo__img promo__img_dw"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <a href="/files/scout_video.mp4" className={"hide-sm"}>
                  <picture>
                    <source srcSet="/files/button.gif" type="image/gif" />
                    <img
                      className="promo__phone-decor"
                      src="/files"
                      alt="gif"
                      style={{ width: "150px" }}
                    />
                  </picture>
                </a>
              </div>
            </div>
            <div className="promo__decor promo__decor_dw">
              <img src="img/promo-robot.png" alt="Image" />
            </div>
          </div>
        </div>
      </section>
      {isContactFormOpen && (
        <ContactFormDW
          onClose={() => setIsContactFormOpen(false)}
          haveBusiness={haveBusiness}
        />
      )}
    </main>
  );
}

export default HomeDW;
